module.exports = __webpack_public_path__ + "fe581aafde4869274d477d2f8bfb4289.png";